


























































import { Component, Prop, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';

import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { Office } from '@/plugins/podolib/services/doctor';

import PatientAcquisitionExportationBuilder from '@/components/patients/acquisition/exportation/PatientAcquisitionExportationBuilder.vue';
import AccountOffices from '@/components/account/AccountOffices.vue';

@Component({
  components: {
    AccountOffices,
    PatientAcquisitionExportationBuilder,
  },
})
export default class PatientAcquisitionExportation extends MixinDialog {
  @Prop({ required: false }) patient!: TEntity<TPatient>;
  @Prop({ required: false }) acquisition!: TAcquisition;

  internalPatient: TEntity<TPatient> | null | undefined = null;
  internalAcquisition: TEntity<TAcquisition> | null | undefined = null;

  @Watch('dialog')
  onDialogChanged(state: boolean) {
    if (state) {
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('Analysis ExporterOpened', {
        patientId: this._patient._id,
        acquisitionId: this._acquisition._id,
      });
    } else {
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('Analysis ExporterClosed', {
        patientId: this._patient._id,
        acquisitionId: this._acquisition._id,
      });
    }
  }

  get doctor() {
    return this.$store.state.pdc.doctor.current;
  }

  get offices(): Office[] {
    return this.doctor.offices.items;
  }
  get _patient() {
    return this.internalPatient || this.patient;
  }

  get _acquisition() {
    return this.internalAcquisition || this.acquisition;
  }

  _open({ patient, acquisition }: { patient: TEntity<TPatient>; acquisition: TEntity<TAcquisition> }) {
    this.internalPatient = patient;
    this.internalAcquisition = acquisition;

    this.open();
  }

  created() {
    this.$pdc.bus!.on('export:open', this._open);
  }
  beforeDestroy() {
    this.$pdc.bus!.off('export:open', this._open);
  }
}
